import styled from 'styled-components'

export const PageDivider = styled.div`
  margin: ${p => p.theme.sizes.ten} 0;
  background-color: ${p => p.theme.colors.gray4};
  min-height: 1px;
  width: 100%;
`
